import useAMRevamp from '~/hooks/useAMRevamp';

import HostingLegacy from './scenes/HostingLegacy';
import HostingRevamp from './scenes/HostingRevamp';

const Hosting = () => {
  const { isAMRevamp } = useAMRevamp();
  console.log('Hosting component triggered, isAMRevamp:', isAMRevamp);
  return isAMRevamp ? <HostingRevamp /> : <HostingLegacy />;
};
export default Hosting;
